module.exports = __webpack_public_path__ + "common/icon-twitter-8015a414b870438a3b48062d1551e915.svg";